import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const buttonPropTypes = {
  badge: PropTypes.bool,
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf(['blue', 'green', 'grey', 'orange', 'red']),
  disabled: PropTypes.bool,
  kind: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'link']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  wrap: PropTypes.bool,
};

const buttonDefaultProps = {
  badge: false,
  color: 'green',
  disabled: false,
  kind: 'primary',
  size: 'small',
  warp: false,
};

const ButtonWrap = styled.button`
  align-items: center;
  background-color: ${
    props => props.kind === 'primary'
      ? props.theme[`btn-${props.color}`]
      : 'transparent'
    };
  border: none;
  border-radius: ${
    props => props.badge
      ? '27px'
      : '6px'
    };
  box-shadow: ${
    props => {
      if (props.disabled || props.kind !== 'primary') {
        return 'none';
      }
      return `1px 2px 6px ${props.theme['grey-normal']}`;
    }};
  color: ${
    props => {
      if (props.color === 'grey') {
        return props.theme['text-black'];
      }
      return props.kind === 'primary'
        ? props.theme['text-white']
        : props.theme[`btn-${props.color}`];
    }};
  display: flex;
  font-family: ${props => props.theme['theme-font']};
  font-size: ${props => props.theme['font-size-normal']};
  font-weight: bold;
  line-height: ${props => props.theme['line-height-normal']};
  justify-content: center;
  opacity: ${props => props.disabled ? 0.5 : 1};
  padding: ${
    props => {
      if (props.badge) {
        return '15px 27px';
      } else if (props.kind === 'link') {
        return '0px';
      } else if (props.size === 'small') {
        return '6px 9px';
      } else if (props.size === 'medium') {
        return '9px 15px';
      }
      return '15px 27px'; // large
    }};
  text-decoration: ${props => props.kind === 'link' ? 'underline' : 'none'};
  text-shadow: ${
    props => props.badge
      ? `1px 1px ${props.theme[`btn-${props.color}-text-shadow`]}`
      : 'none'
    };
  text-transform: ${
    props => props.badge
      ? 'uppercase'
      : 'none'
    };
  white-space: ${props => props.wrap ? 'normal' : 'nowrap'};

  :hover {
    box-shadow: ${
      props => {
        if (props.disabled || props.kind !== 'primary') {
          return 'none';
        }
        return `1px 2px 6px ${props.theme['grey-dark']}`;
      }};
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  }

  :focus {
    outline: none;
  }
`;

const Button = ({ children, ...props }) =>
  <ButtonWrap {...props}>
    {children}
  </ButtonWrap>;

Button.propTypes = buttonPropTypes;
Button.defaultProps = buttonDefaultProps;

export default Button;
